const url = '/companyTypes';
const Provider = 'CompanyTypes';
const dbModel = 'CompanyTypes';

export { url, Provider, dbModel };
